// Img
// import instaImg from "../../../assets/svg/social/instagram.svg";
// import twitterImg from "../../../assets/svg/social/twitter.svg";
// import fbImg from "../../../assets/svg/social/facebook.svg";
// import youtubeImg from "../../../assets/svg/social/youtube.svg";
import playstoreImg from "../../../assets/svg/store/google-play.svg";
import appstoreImg from "../../../assets/svg/store/app-store.svg";
import jioDotLogo from "../../../assets/svg/jio-dot.svg";

// Css
import classes from "./Footer.module.css";

// Mui
import { Box, Divider, Stack, Typography } from "@mui/material";
import { Icon } from "@jds/core";

export default function Footer(props) {
  return (
    <footer className={classes.footer}>
      <div className={classes["footer__content"]}>
        <Stack direction="column" gap={4}>
          <Box textAlign="center">
            <Typography
              variant="subtitle2"
              fontFamily="var(--font-bold)"
              mb={2}
            >
              Connect with us
            </Typography>
            <ul className={classes["social__links"]}>
              <li>
                <a href="">
                  {/* <img src={fbImg} alt="facebook icon" /> */}
                  <Icon size="large" ic="IcFacebook" kind="background-bold" />
                </a>
              </li>
              <li>
                <a href="">
                  {/* <img src={twitterImg} alt="twitter icon" /> */}
                  <Icon size="large" ic="IcTwitter" kind="background-bold" />
                </a>
              </li>
              <li>
                <a href="">
                  {/* <img src={instaImg} alt="instagram icon" /> */}
                  <Icon size="large" ic="IcInstagram" kind="background-bold" />
                </a>
              </li>
              <li>
                <a href="">
                  {/* <img src={youtubeImg} alt="youtube icon" /> */}
                  <Icon size="large" ic="IcYoutube" kind="background-bold" />
                </a>
              </li>
            </ul>
          </Box>
          <Box textAlign="center">
            <Typography
              variant="subtitle2"
              fontFamily="var(--font-bold)"
              mb={2}
            >
              Download JioPhotos
            </Typography>
            <Stack direction="row" gap={"12px"}>
              <a href="https://play.google.com/store/apps/details?id=com.jio.snap">
                <img src={playstoreImg} alt="playstore" />
              </a>
              <a href="https://apps.apple.com/in/app/jiophotos/id6450602471">
                <img src={appstoreImg} alt="appstore" />
              </a>
            </Stack>
          </Box>
        </Stack>
      </div>
      <Divider />
      <div className={classes["footer__legal"]}>
        <div className="inner-container">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Stack direction="row" alignItems="center" gap={2}>
              <Box>
                {/* <img src={jioDotLogo} alt="jio logo" /> */}
                <Icon size="large" ic="IcJioDot" />
              </Box>
              <Typography variant="subtitle2" fontSize="12px">
                Copyright © 2021 Reliance Jio Infocomm Ltd. All rights reserved.
              </Typography>
            </Stack>
            <div
              style={{
                zIndex: "100000",
              }}
            >
              <ul className={classes["legal__items"]}>
                <li>
                  <a
                    onClick={(e) => {
                      e.preventDefault();

                      const targetElement =
                        document.querySelector("#section-4");

                      targetElement.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }}
                  >
                    How it works
                  </a>
                </li>
                <li>
                  <a
                    href="/privacy-policy.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a
                    // href="https://www.jio.com/jcms/en-in/terms-conditions/"
                    href="https://www.jio.com/jcms/en-in/jiophotos-terms-and-conditions/"
                    target="_blank"
                  >
                    Terms & Conditions
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
